<template>
  <div v-if="currentChecklist && currentComponent">
    <components
      :is="currentComponent"
      :currentChecklist="currentChecklist"
      :ordre="ordre"
    />
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/checklist-question';
import QcmCreate from '../components/qcm/Create.vue';
import QrmCreate from '../components/qrm/Create.vue';
import QvfCreate from '../components/qvf/Create.vue';
import QnCreate from '../components/qn/Create.vue';
import QcCreate from '../components/qc/Create.vue';
import QlCreate from '../components/ql/Create.vue';
import QrsCreate from '../components/qrs/Create.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentComponent: null,
      ordre: 0,
    };
  },

  watch: {
    '$route.params.type': {
      handler: function (value) {
        switch (value) {
          case 'qcm':
            this.currentComponent = QcmCreate;
            break;
          case 'qrm':
            this.currentComponent = QrmCreate;
            break;
          case 'qvf':
            this.currentComponent = QvfCreate;
            break;
          case 'qrn':
            this.currentComponent = QnCreate;
            break;
          case 'qrc':
            this.currentComponent = QcCreate;
            break;
          case 'qrl':
            this.currentComponent = QlCreate;
            break;
          case 'qrs':
            this.currentComponent = QrsCreate;
            break;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
  },
  mounted() {
    window.axios
      .get(URL.QUESTION_NUMBER + '/' + this.$route.params.id)
      .then((resp) => {
        this.ordre = resp.data.number;
        console.log(this.ordre);
      })
      .catch();
  },
};
</script>

<style scoped></style>
